import { useState, useEffect } from 'react';
import { db } from '../firebase/config';
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  doc,
  getDoc,
  setDoc,
  where,
  query,
  serverTimestamp,
  deleteDoc,
} from 'firebase/firestore';
import logo from '../asset/logoSumaSalto.png'; // ajustá el path si tu logo está en otra carpeta
import { getAuth, createUserWithEmailAndPassword } from 'firebase/auth';
import { signOut } from "firebase/auth";
import Footer from "../asset/components/Footer";

function GestionConfigGlobal() {
  const [config, setConfig] = useState({
    ValorCanjeGlobal: 3,
    Vueltas: 3,
    MontoMaximo: 5000,
    TopeTipo: "dinero",
  });

  const configRef = doc(db, "config", "global");

  // cargar config existente al montar
  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const snap = await getDoc(configRef);
        if (snap.exists()) {
          setConfig(snap.data());
        }
      } catch (err) {
        console.error("❌ Error al cargar configuración:", err);
      }
    };
    fetchConfig();
  }, []);

  // cambios en inputs
  const handleChange = (e) => {
    const { name, value } = e.target;
    setConfig((prev) => ({
      ...prev,
      [name]: name === "Vueltas" || name === "MontoMaximo" || name === "ValorCanjeGlobal"
        ? Number(value)
        : value,
    }));
  };

  // guardar en firestore
  const handleSave = async (e) => {
    e.preventDefault();
    try {
      await setDoc(configRef, config, { merge: true });
      alert("✅ Configuración global actualizada");
    } catch (err) {
      console.error("❌ Error guardando configuración:", err);
      alert("Error guardando configuración");
    }
  };

  return (
    <div className="mt-6 p-4 border rounded bg-gray-50">
      <h2 className="font-bold text-lg mb-2">⚙️ Configuración Global</h2>
      <form onSubmit={handleSave} className="space-y-3">
        <div>
          <label className="block font-semibold">Valor Canje Global</label>
          <input
            type="number"
            name="ValorCanjeGlobal"
            value={config.ValorCanjeGlobal}
            onChange={handleChange}
            className="border px-2 py-1 rounded w-full"
          />
        </div>

        <div>
          <label className="block font-semibold">Vueltas (nº visitas)</label>
          <input
            type="number"
            name="Vueltas"
            value={config.Vueltas}
            onChange={handleChange}
            className="border px-2 py-1 rounded w-full"
          />
        </div>

        <div>
          <label className="block font-semibold">Monto Máximo</label>
          <input
            type="number"
            name="MontoMaximo"
            value={config.MontoMaximo}
            onChange={handleChange}
            className="border px-2 py-1 rounded w-full"
          />
        </div>

        <div>
          <label className="block font-semibold">Tope Tipo</label>
          <select
            name="TopeTipo"
            value={config.TopeTipo}
            onChange={handleChange}
            className="border px-2 py-1 rounded w-full"
          >
            <option value="dinero">Dinero</option>
            <option value="puntos">Puntos</option>
          </select>
        </div>

        <button
          type="submit"
          className="bg-blue-600 text-white px-3 py-1 rounded"
        >
          Guardar Configuración
        </button>
      </form>
    </div>
  );
}



// ------------------ Gestión de Comercios ------------------
// Panel de administración completo:
// - Alta / edición de comercios
// - Campos históricos preservados
// - Agrega RUT (clave para QR DGI)
// - Flag de autogestión QR (no deshabilita carga manual)

function GestionComercios() {

  // ============================
  // STATE
  // ============================

  // Lista de comercios
  const [comercios, setComercios] = useState([]);

  // Formulario de alta / edición
  const [nuevoComercio, setNuevoComercio] = useState({
    nombre: '',
    email: '',
    direccion: '',
    telefono: '',
    rut: '',                 // 👈 NUEVO (clave QR)
    ValorPunto: '',
    claveComercio: '',
    linkPerfilGoogle: '',
    autogestionQR: false     // 👈 NUEVO (flag)
  });

  // Control de edición
  const [modoEdicion, setModoEdicion] = useState(false);
  const [idEditando, setIdEditando] = useState(null);

  const comerciosRef = collection(db, 'comercios');

  // ============================
  // EFFECTS
  // ============================

  useEffect(() => {
    cargarComercios();
  }, []);

  // ============================
  // HELPERS
  // ============================

  // Cargar lista de comercios
  const cargarComercios = async () => {
    const snapshot = await getDocs(comerciosRef);
    const lista = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
    setComercios(lista);
  };

  // Manejo genérico de inputs
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    setNuevoComercio({
      ...nuevoComercio,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  // ============================
  // CREAR / ACTUALIZAR COMERCIO
  // ============================

  const handleCrearComercio = async (e) => {
    e.preventDefault();

    // Validación mínima clave
    if (!nuevoComercio.rut) {
      alert('El RUT del comercio es obligatorio');
      return;
    }

    // --------- EDICIÓN ---------
    if (modoEdicion) {
      const comercioDoc = doc(db, 'comercios', idEditando);

      await updateDoc(comercioDoc, {
        ...nuevoComercio
      });

      setModoEdicion(false);
      setIdEditando(null);
    }

    // --------- ALTA NUEVA ---------
    else {
      const auth = getAuth();

      try {
        // 1️⃣ Crear usuario Auth
        const userCredential = await createUserWithEmailAndPassword(
          auth,
          nuevoComercio.email,
          nuevoComercio.claveComercio
        );

        const uid = userCredential.user.uid;

        // 2️⃣ Crear documento Firestore (ID = UID)
        const comercioData = {
          ...nuevoComercio,
          uid,
          activo: true,
          fechaRegistro: new Date().toISOString()
        };

        await setDoc(doc(db, 'comercios', uid), comercioData);

      } catch (error) {
        console.error('❌ Error al crear comercio:', error.message);
        return;
      }
    }

    // Reset formulario
    setNuevoComercio({
      nombre: '',
      email: '',
      direccion: '',
      telefono: '',
      rut: '',
      ValorPunto: '',
      claveComercio: '',
      linkPerfilGoogle: '',
      autogestionQR: false
    });

    cargarComercios();
  };

  // ============================
  // EDITAR COMERCIO
  // ============================

  const handleEditar = (comercio) => {
    setNuevoComercio({
      nombre: comercio.nombre,
      email: comercio.email,
      direccion: comercio.direccion,
      telefono: comercio.telefono,
      rut: comercio.rut || '',
      ValorPunto: comercio.ValorPunto,
      claveComercio: comercio.claveComercio,
      linkPerfilGoogle: comercio.linkPerfilGoogle || '',
      autogestionQR: comercio.autogestionQR || false
    });

    setModoEdicion(true);
    setIdEditando(comercio.id);
  };

  // ============================
  // DESACTIVAR COMERCIO
  // ============================

  const handleDesactivar = async (id) => {
    const comercioDoc = doc(db, 'comercios', id);
    await updateDoc(comercioDoc, { activo: false });

    setComercios(comercios.map(c =>
      c.id === id ? { ...c, activo: false } : c
    ));
  };

  // ============================
  // RENDER
  // ============================

  return (
    <div className="mt-6">
      <h2 className="font-bold mb-2">Gestión de Comercios</h2>

      {/* ---------- FORMULARIO ---------- */}
      <form onSubmit={handleCrearComercio} className="space-y-2">
        <input name="nombre" placeholder="Nombre" value={nuevoComercio.nombre} onChange={handleInputChange} required className="border px-2 py-1 w-full" />
        <input name="email" placeholder="Email" value={nuevoComercio.email} onChange={handleInputChange} required className="border px-2 py-1 w-full" />
        <input name="direccion" placeholder="Dirección" value={nuevoComercio.direccion} onChange={handleInputChange} required className="border px-2 py-1 w-full" />
        <input name="telefono" placeholder="Teléfono" value={nuevoComercio.telefono} onChange={handleInputChange} required className="border px-2 py-1 w-full" />

        <input name="rut" placeholder="RUT del comercio" value={nuevoComercio.rut} onChange={handleInputChange} required className="border px-2 py-1 w-full" />

        <input name="ValorPunto" placeholder="Valor del punto" value={nuevoComercio.ValorPunto} onChange={handleInputChange} required className="border px-2 py-1 w-full" />

        <input name="claveComercio" placeholder="Clave del comercio" value={nuevoComercio.claveComercio} onChange={handleInputChange} required className="border px-2 py-1 w-full" />

        <input name="linkPerfilGoogle" placeholder="Link perfil Google (opcional)" value={nuevoComercio.linkPerfilGoogle} onChange={handleInputChange} className="border px-2 py-1 w-full" />

        <label className="flex items-center space-x-2">
          <input type="checkbox" name="autogestionQR" checked={nuevoComercio.autogestionQR} onChange={handleInputChange} />
          <span>Habilitar autogestión por QR (no desactiva carga manual)</span>
        </label>

        <button type="submit" className="bg-blue-600 text-white px-3 py-1 rounded">
          {modoEdicion ? 'Actualizar Comercio' : 'Crear Comercio'}
        </button>

        {modoEdicion && (
          <button
            type="button"
            onClick={() => {
              setModoEdicion(false);
              setIdEditando(null);
              setNuevoComercio({
                nombre: '',
                email: '',
                direccion: '',
                telefono: '',
                rut: '',
                ValorPunto: '',
                claveComercio: '',
                linkPerfilGoogle: '',
                autogestionQR: false
              });
            }}
            className="bg-gray-400 text-white px-3 py-1 rounded ml-2"
          >
            Cancelar
          </button>
        )}
      </form>

      {/* ---------- TABLA ---------- */}
      <h3 className="text-lg font-semibold mt-6">Lista de Comercios</h3>

      <table className="min-w-full border mt-2 text-sm text-left">
        <thead className="bg-gray-100">
          <tr>
            <th className="border px-2 py-1">Nombre</th>
            <th className="border px-2 py-1">Email</th>
            <th className="border px-2 py-1">Dirección</th>
            <th className="border px-2 py-1">Teléfono</th>
            <th className="border px-2 py-1">RUT</th>
            <th className="border px-2 py-1">Valor Punto</th>
            <th className="border px-2 py-1">Clave</th>
            <th className="border px-2 py-1">Google</th>
            <th className="border px-2 py-1">QR</th>
            <th className="border px-2 py-1">Estado</th>
            <th className="border px-2 py-1">Acciones</th>
          </tr>
        </thead>

        <tbody>
          {comercios.map(c => (
            <tr key={c.id}>
              <td className="border px-2 py-1">{c.nombre}</td>
              <td className="border px-2 py-1">{c.email}</td>
              <td className="border px-2 py-1">{c.direccion}</td>
              <td className="border px-2 py-1">{c.telefono}</td>
              <td className="border px-2 py-1">{c.rut}</td>
              <td className="border px-2 py-1 text-center">{c.ValorPunto}</td>
              <td className="border px-2 py-1">{c.claveComercio}</td>
              <td className="border px-2 py-1">
                {c.linkPerfilGoogle
                  ? <a href={c.linkPerfilGoogle} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">Ver</a>
                  : '—'}
              </td>
              <td className="border px-2 py-1 text-center">{c.autogestionQR ? '✅' : '—'}</td>
              <td className="border px-2 py-1">{c.activo ? 'Activo' : 'Inactivo'}</td>
              <td className="border px-2 py-1">
                <button onClick={() => handleEditar(c)} className="bg-yellow-500 text-white px-2 py-1 mr-1 rounded">Editar</button>
                <button onClick={() => handleDesactivar(c.id)} className="bg-red-500 text-white px-2 py-1 rounded">Desactivar</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}



// ------------------ Gestion Clientes ------------------
function GestionClientes() {
  const [ci, setCi] = useState('');
  const [cliente, setCliente] = useState(null);
  const [error, setError] = useState('');
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    ci: '',
    puntos: 0,
    comercioOrigen: '',
  });

  // Buscar cliente por CI (docId == ci)
  const buscarCliente = async () => {
    try {
      const valor = ci.trim();
      if (!valor) {
        setError("Debe ingresar un CI");
        return;
      }

      const ref = doc(db, "clientes", valor);
      const snap = await getDoc(ref);

      if (!snap.exists()) {
        setError("Cliente no encontrado");
        setCliente(null);
        setFormData({
          nombre: "",
          email: "",
          ci: valor,
          puntos: 0,
          comercioOrigen: "",
        });
      } else {
        const data = { id: snap.id, ...snap.data() };
        setCliente(data);
        setFormData({
          nombre: data.nombre || "",
          email: data.email || "",
          ci: data.ci || valor,
          puntos: data.puntos || 0,
          comercioOrigen: data.comercioOrigen || "",
        });
        setError("");
      }
    } catch (e) {
      console.error("Error en la búsqueda:", e);
      setError("Ocurrió un error al buscar el cliente");
    }
  };

  // Manejar cambios en formulario
  const manejarCambio = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Alta de cliente con ci == id
  const guardarCliente = async () => {
    try {
      const valor = formData.ci.trim();
      if (!valor) {
        alert("Debe ingresar un CI");
        return;
      }

      const clienteRef = doc(db, "clientes", valor);

      // 🔗 Generar automáticamente el linkPWA
      const linkPWA = `https://apisumauy.1montonx2.com/PWACliente/?id=${encodeURIComponent(valor)}`;

      const nuevoCliente = {
        ...formData,
        ci: valor,
        puntos: Number(formData.puntos) || 0,
        fechaRegistro: serverTimestamp(),
        activo: true,
        historialCanjes: [],
        ultimoCanje: null,
        linkPWA, // Guardamos el link en la BD
      };

      await setDoc(clienteRef, nuevoCliente);
      setCliente({ id: valor, ...nuevoCliente });
      setError("");

      // ✅ Enviar email al cliente con fetch a sendMail.php
      try {
        const response = await fetch("https://apisumauy.1montonx2.com/sendMail.php", {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8" },
          body: new URLSearchParams({
            to: formData.email,
            subject: "Bienvenido a SumaSalto",
            message: `Hola ${formData.nombre}, gracias por unirte a SUMA. Aquí tienes el acceso a tu PWA Cliente. 
Puedes instalarla en tu celular para seguir tus puntos y beneficios. 

📱 En ANDROID: Abrí la app en tu navegador Chrome y seleccioná “Agregar a pantalla principal”.
🍏 En iOS: Abrí la app en Safari, tocá el ícono de compartir y luego seleccioná “Agregar a pantalla de inicio”`,
            link: linkPWA,
          }),
        });

        const result = await response.text();
        console.log("📨 Respuesta del servidor:", result);
        alert("Cliente guardado y email enviado correctamente");
      } catch (mailError) {
        console.error("Error al enviar email:", mailError);
        alert("Cliente guardado, pero ocurrió un error al enviar el email");
      }

      // limpiar formulario
      setFormData({
        nombre: "",
        email: "",
        ci: "",
        puntos: 0,
        comercioOrigen: "",
        historialCanjes: [],
        ultimoCanje: null
      });
    } catch (e) {
      console.error("Error al guardar cliente:", e.message, e.code);
      alert(`Ocurrió un error al guardar el cliente: ${e.message}`);
    }
  };

  // Modificar cliente existente
  const modificarCliente = async () => {
    try {
      const valor = formData.ci.trim();
      if (!valor) {
        alert("CI inválido para modificar");
        return;
      }

      const clienteRef = doc(db, "clientes", valor);
      await updateDoc(clienteRef, {
        ...formData,
        puntos: Number(formData.puntos) || 0,
      });

      alert("Cliente modificado correctamente");

      setFormData({
        nombre: "",
        email: "",
        ci: "",
        puntos: 0,
        comercioOrigen: "",
      });
    } catch (e) {
      console.error("Error al modificar cliente:", e);
      alert("Ocurrió un error al modificar el cliente");
    }
  };

  // Reenviar el linkPWA
  const reenviarLink = async () => {
    if (cliente?.linkPWA) {
      try {
        const response = await fetch("https://apisumauy.1montonx2.com/sendMail.php", {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: new URLSearchParams({
            to: cliente.email,
            subject: "Reenvío de tu acceso a la PWA Cliente",
            message: `Hola ${cliente.nombre}, aquí tienes nuevamente el link para acceder a tu PWA Cliente.`,
            link: cliente.linkPWA,
          }),
        });

        const result = await response.text();
        console.log("📨 Respuesta del servidor:", result);
        alert("Email reenviado correctamente");
      } catch (mailError) {
        console.error("Error al reenviar email:", mailError);
        alert("Ocurrió un error al reenviar el email");
      }
    }
  };

  return (
    <div className="mt-6">
      <h2 className="font-bold mb-2">Gestión de Clientes</h2>
      {/* Aquí tu tabla y funcionalidad actual */}
      <div className="p-4">
        <h2 className="text-xl font-bold mb-2">Buscar Cliente por CI</h2>
        <input
          type="text"
          value={ci}
          onChange={(e) => setCi(e.target.value)}
          placeholder="Ingrese CI"
          className="border px-2 py-1 mr-2 rounded"
        />
        <button onClick={buscarCliente} className="bg-blue-500 text-white px-3 py-1 rounded">
          Buscar
        </button>

        {error && <p className="text-red-500 mt-2">{error}</p>}

        <div className="mt-4 border p-4 rounded bg-gray-50">
          <h3 className="font-semibold text-lg mb-2">{cliente ? 'Modificar Cliente' : 'Nuevo Cliente'}</h3>
          <div className="grid grid-cols-2 gap-2">
            <input name="nombre" type="text" value={formData.nombre} onChange={manejarCambio} placeholder="Nombre" className="border px-2 py-1 rounded" />
            <input name="email" type="email" value={formData.email} onChange={manejarCambio} placeholder="Email" className="border px-2 py-1 rounded" />
            <input name="ci" type="text" value={formData.ci} onChange={manejarCambio} placeholder="CI" className="border px-2 py-1 rounded" />
            <input name="puntos" type="number" value={formData.puntos} onChange={manejarCambio} placeholder="Puntos" className="border px-2 py-1 rounded" />
            <input name="comercioOrigen" type="text" value={formData.comercioOrigen} onChange={manejarCambio} placeholder="Comercio Origen" className="border px-2 py-1 rounded" />
          </div>

          {!cliente ? (
            <button onClick={guardarCliente} className="mt-4 bg-green-500 text-white px-3 py-1 rounded">
              Guardar Cliente
            </button>
          ) : (
            <>
              <button onClick={modificarCliente} className="mt-4 bg-yellow-500 text-white px-3 py-1 rounded">
                Modificar Cliente
              </button>

              {/* 🔗 Mostrar linkPWA si existe */}
              {cliente.linkPWA && (
                <div className="mt-4">
                  <p className="text-sm">
                    <strong>Link PWA:</strong>{" "}
                    <a
                      href={cliente.linkPWA}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600 underline"
                    >
                      {cliente.linkPWA}
                    </a>
                  </p>
                  <button onClick={reenviarLink} className="bg-purple-500 text-white px-3 py-1 rounded mt-2">
                    Reenviar Link
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}


// ------------------ Panel Administrador ------------------
export default function PanelAdministrador() {
  const [mensajeExito, setMensajeExito] = useState("");
  const [notificacionesPendientes, setNotificacionesPendientes] = useState([]);

    //Funcion logout
    const handleLogout = async () => {
    const auth = getAuth();
    try {
      await signOut(auth);
      console.log("✅ Sesión cerrada correctamente");
      window.location.href = "/panel"; // o la ruta que uses para el login
    } catch (error) {
      console.error("❌ Error al cerrar sesión:", error.message);
    }
  };

  // Cargar notificaciones no aprobadas
  const cargarPendientes = async () => {
    try {
      const q = query(collection(db, "notificaciones"), where("aprobado", "==", false));
      const snapshot = await getDocs(q);
      const lista = snapshot.docs.map((docSnap) => ({
        id: docSnap.id,
        ...docSnap.data(),
      }));
      setNotificacionesPendientes(lista);
    } catch (error) {
      console.error("❌ Error cargando notificaciones pendientes:", error);
    }
  };

  // Aprobar
  const aprobarNotificacion = async (id) => {
    try {
      await updateDoc(doc(db, "notificaciones", id), { aprobado: true });
      setNotificacionesPendientes((prev) => prev.filter((n) => n.id !== id));
      setMensajeExito("✅ Notificación aprobada con éxito");
      setTimeout(() => setMensajeExito(""), 3000);
    } catch (error) {
      console.error("❌ Error aprobando notificación:", error);
    }
  };

  // Rechazar
  const rechazarNotificacion = async (id) => {
    try {
      await deleteDoc(doc(db, "notificaciones", id));
      setNotificacionesPendientes((prev) => prev.filter((n) => n.id !== id));
      setMensajeExito("🗑 Notificación rechazada");
      setTimeout(() => setMensajeExito(""), 3000);
    } catch (error) {
      console.error("❌ Error rechazando notificación:", error);
    }
  };

  useEffect(() => {
    cargarPendientes();
  }, []);

  return (
    <div className="p-4">
      {/* Header */}
      <img src={logo} alt="logoSumaSalto.png" style={{ height: "100px", width: "auto" }} />
      <h1 className="text-2xl font-bold mb-4">Panel Administrador</h1>

      {/* Bloques de gestión */}
      <GestionComercios />
      <GestionClientes />
      <GestionConfigGlobal />


      {/* Bloque Notificaciones */}
      <div className="mt-8">
        <h2 className="font-bold text-lg mb-2">📢 Notificaciones Pendientes</h2>

   

        {mensajeExito && <p className="text-green-600">{mensajeExito}</p>}

        {notificacionesPendientes.length === 0 ? (
          <p>No hay notificaciones pendientes</p>



        ) : (
          <ul>
            {notificacionesPendientes.map((notif) => (
              <li
                key={notif.id}
                style={{
                  border: "1px solid #ccc",
                  padding: "10px",
                  marginBottom: "10px",
                  borderRadius: "6px",
                }}
              >
                <strong>{notif.nombreComercio}</strong> - <em>{notif.titulo}</em>
                <p>{notif.mensaje}</p>
                <div className="flex gap-2 mt-2">
                  <button
                    onClick={() => aprobarNotificacion(notif.id)}
                    className="bg-green-500 text-white px-3 py-1 rounded"
                  >
                    ✅ Aprobar
                  </button>
                  <button
                    onClick={() => rechazarNotificacion(notif.id)}
                    className="bg-red-500 text-white px-3 py-1 rounded"
                  >
                    ❌ Rechazar
                  </button>

                </div>

              </li>
            ))}
          </ul>
        )}

                <button 
  onClick={handleLogout} 
  className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
>
  Cerrar Sesión
</button>
      </div>

    {/* Footer */}
      <Footer />
    </div>
  );
}












